const assignProps = (props, defaultProps) => {
  return { ...defaultProps, props };
};

export default assignProps;
